import React, { useState, useRef } from 'react';
import { Modal, Button, Form, Alert, ProgressBar } from 'react-bootstrap';
import { FaUpload, FaDownload } from 'react-icons/fa';

const AssetBulkOperations = ({ show, onHide, onRefresh }) => {
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const fileInputRef = useRef(null);

    const handleImportAssets = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/bulkoperations/import-assets', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: formData
            });

            const data = await response.json();
            setResult(data);
            if (data.successCount > 0 && onRefresh) onRefresh();
        } catch (error) {
            setResult({ successCount: 0, errorCount: 1, errors: [error.message] });
        } finally {
            setLoading(false);
        }
    };

    const handleExportAssets = async () => {
        try {
            const response = await fetch('/api/bulkoperations/export-assets', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'assets.csv';
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            setResult({ successCount: 0, errorCount: 1, errors: [error.message] });
        }
    };

    const downloadTemplate = () => {
        const csv = "Name,AssetType,PurchaseDate,PurchasePrice,Quantity,Description\n" +
                   "Laptop Dell,Laptop,2024-01-15,50000,1,Dell Inspiron 15\n" +
                   "Mouse Logitech,Mouse,2024-01-15,1500,5,Wireless Mouse";
        
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'asset_import_template.csv';
        a.click();
        window.URL.revokeObjectURL(url);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg">
            <Modal.Header closeButton>
                <Modal.Title><FaUpload className="me-2" />Asset Bulk Operations</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {result && (
                    <Alert variant={result.errorCount > 0 ? 'warning' : 'success'} className="mb-3">
                        <strong>Operation Complete:</strong> {result.successCount} successful, {result.errorCount} errors
                        {result.errors.length > 0 && (
                            <ul className="mt-2 mb-0">
                                {result.errors.slice(0, 5).map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                                {result.errors.length > 5 && <li>... and {result.errors.length - 5} more errors</li>}
                            </ul>
                        )}
                    </Alert>
                )}

                {loading && <ProgressBar animated now={100} className="mb-3" />}

                <h5>Import Assets</h5>
                <div className="mb-3">
                    <Button variant="outline-secondary" size="sm" onClick={downloadTemplate}>
                        Download Template
                    </Button>
                </div>
                <Form.Group className="mb-4">
                    <Form.Label>Select CSV File</Form.Label>
                    <Form.Control 
                        type="file" 
                        accept=".csv"
                        ref={fileInputRef}
                        onChange={handleImportAssets}
                        disabled={loading}
                    />
                    <Form.Text className="text-muted">
                        CSV format: Name, AssetType, PurchaseDate (YYYY-MM-DD), PurchasePrice, Quantity, Description
                    </Form.Text>
                </Form.Group>

                <hr />

                <h5>Export Assets</h5>
                <Button variant="success" onClick={handleExportAssets}>
                    <FaDownload className="me-1" /> Export All Assets
                </Button>
            </Modal.Body>
        </Modal>
    );
};

export default AssetBulkOperations;